import { PreviewRow, RecoveryPlan } from '../feature/arrearsDecisions';

export const isIsoDate = (value: string | null | undefined) =>
  typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value) && !Number.isNaN(Date.parse(`${value}T00:00:00Z`));

const addMonths = (iso: string, months: number) => {
  const [y, m, d] = iso.split('-').map(Number);
  const target = new Date(Date.UTC(y, m - 1 + months, 1));
  const lastDay = new Date(Date.UTC(target.getUTCFullYear(), target.getUTCMonth() + 1, 0)).getUTCDate();
  target.setUTCDate(Math.min(d, lastDay));
  return target.toISOString().slice(0, 10);
};

const round2 = (n: number) => Math.round(n * 100) / 100;

// Mirrors Oto::ArrearsDecisions::Propose#spread: whole pennies, remainder on the first collection,
// never more collections than pennies.
export const spreadPlan = (arrearsPerStudent: number, requestedCount: number) => {
  const pence = Math.round(arrearsPerStudent * 100);
  const count = Math.min(Math.max(Math.floor(requestedCount) || 1, 1), Math.max(pence, 1));
  if (count === 1) return { initialTake: round2(pence / 100), regularTake: round2(pence / 100), noPayments: 1 };
  const base = Math.floor(pence / count);
  const remainder = pence - base * count;
  return { initialTake: round2((base + remainder) / 100), regularTake: round2(base / 100), noPayments: count };
};

// Mirrors Oto::ArrearsDecisions::Preview#schedule_rows so edits re-render instantly without a round trip.
export const buildRecoveryRows = (plan: RecoveryPlan, students: number, usualAmount: number, usualMonths: string[]): PreviewRow[] => {
  if (!isIsoDate(plan.firstCollectionDate)) return [];
  const count = Math.max(plan.noPayments, 0);
  const qty = Math.max(students, 1);
  return Array.from({ length: count }, (_, i) => {
    const date = addMonths(plan.firstCollectionDate, i);
    const perStudent = i === 0 ? plan.initialTake : plan.regularTake;
    const extra = round2(perStudent * qty);
    const usual = usualMonths.includes(date.slice(0, 7)) ? round2(usualAmount) : 0;
    return { date, extra, usual, total: round2(extra + usual) };
  });
};

export const recoveryTotal = (rows: PreviewRow[]) => round2(rows.reduce((sum, r) => sum + r.extra, 0));
